import React from 'react';
import './ApplicationDetailsList.css';

export default function ApplicationDetailsList({ entries }) {
  const visibleEntries = entries.filter(entry => entry && entry.value !== undefined && entry.value !== null && entry.value !== '');
  return (
    <dl className="application-details-list">
      {visibleEntries.map((entry, index) => (
        <div key={entry.key || `${entry.label}-${index}`}>
          <dt>{entry.label}</dt>
          <dd>{entry.value}</dd>
        </div>
      ))}
    </dl>
  );
}
